import client from './client';

export const getJourney = async () => {
	const response = await client.get('/api/journey');

	return response.data;
};

export const switchJourneyFocus = async (stage) => {
	const response = await client.post('/api/journey/focus', { stage });

	return response.data;
};

export const switchBackJourneyFocus = async () => {
	const response = await client.delete('/api/journey/focus');

	return response.data;
};

export const markConnectGmailShown = async () => {
	await client.post('/api/journey/connect-gmail/shown');
};

export const markProfileFieldsShown = async (fields) => {
	await client.post('/api/journey/profile-fields/shown', { fields });
};

export const reportRecommendationIssue = async ({ message, platform }) => {
	const response = await client.post('/api/journey/reports', { message, platform });

	return response.data;
};

export const keepJourneySettings = async () => {
	const response = await client.post('/api/journey/settings-mismatch/keep');

	return response.data;
};

// Answers with the journey in `data` and `meta.user`: the user keys the save changed, as Profile's save does.
export const saveJourneySettings = async (settings) => client.put('/api/journey/settings-mismatch/settings', settings);
